<template >
  <div class="card p-4">
    <div style="margin-bottom: 60px" class="row">
      <div v-if="showCombineRoom" class="col-md-6 room-title">
        <h2>{{ $t("SearchResults.Select") }} <span>{{ $t("HomeHeader.Room") }}</span></h2>
      </div>
      <div v-else class="col-md-6 room-title">
        <h2> {{ $t("SearchResults.OurChoosenSuggestion") }} <span>{{ $t("HomeHeader.Room") }}</span></h2>
      </div>
      <div class="col-md-6" style="text-align: left;padding: 0;" v-if="checkIsDisable">
        <button v-if="!showCombineRoom" class="button arrow">
         {{ $t("SearchResults.ChooseMyself") }}
        </button>

        <button v-if="showCombineRoom" class="button arrow">{{ $t("SearchResults.OurSuggestion") }}</button>

        <!-- <button v-if="!showCombineRoom" class="btn btn_room" disabled>
          خودم انتخاب می کنم
        </button> -->
        <!-- <button v-if="showCombineRoom" class="btn btn_room" disabled>
          پیشنهاد ما
        </button> -->
      </div>
      <div class="col-md-6" style="text-align: left;padding: 0;" v-else>
        <button v-if="!showCombineRoom" @click="combineRoom()" class="button arrow">
           {{ $t("SearchResults.IChooseMyself") }}
        </button>
        <button v-if="showCombineRoom" @click="showCombineRoom = false" class="button arrow">
           {{ $t("SearchResults.OurSuggestion") }} 
        </button>

        <!-- <button
          v-if="!showCombineRoom"
          class="btn btn_room"
          @click="combineRoom()"
        >
          خودم انتخاب می کنم
        </button> -->
        <!-- <button
          v-if="showCombineRoom"
          class="btn btn_room"
          @click="showCombineRoom = false"
        >
          پیشنهاد ما
        </button> -->
      </div>
    </div>
    <!-- <CombiningRoom @selected="onSelectedCombinedRooms($event)" v-if="showCombineRoom" :rooms ="roomsAvail.availableRoomTypes" /> -->
    <RoomCard :isDisableButton="isDisableButton" :roomRequest="roomsAvail.availableRoomTypes" v-if="showCombineRoom"
      @selected="onSelectedCombinedRooms($event)" />

    <div v-if="!showCombineRoom">
      <div v-for="(option, index) in paginatedRoomsOption" :key="index" class="strip_all_tour_list wow fadeIn"
        data-wow-delay="0.1s" style="
          visibility: visible;
          animation-delay: 0.1s;
          animation-name: fadeIn;
        ">
        <div class="row">
          <div class="col-lg-9 col-md-9">
            <div style="height: auto" class="tour_list_desc">
              <div class="choice row">
                <div class="option-title the-icons">
                  <i class="icon-ok filter-icon"></i>
                  <span class="i-name"> {{ $t("SearchResults.Select") }} {{ index + 1 }}</span>
                </div>
                <div id="room_combine">
                  <div v-for="(room, roomIndex) in option" :key="roomIndex" class="row room">
                    <div class="col-md-2">
                      <img v-if="room.roomTypeImages.length > 0" :src="
                        roomsAvail.roomImageUrl +
                        room.roomTypeImages[0].roomTypeImageID
                      " class="room_image" />
                      <img v-else class="room_image" :src="roomsAvail.roomImageUrl + 'sdasds'" alt="" />
                    </div>
                    <div style="margin-top: 6px" class="col-md-10">
                      <div class=" row">
                        <span class="col-md-7" id="title">{{ room.name }} <label></label></span>
                        <div class="col-md-5 row room-info">
                          <div id="capacity">
                            <i class="pax-icon icon-adult filter-icon"></i>

 {{ $t("SearchResults.Capacity") }} : <span>{{ room.capacity }}</span>
                          </div>

                          <div id="exterabed">
                            <i class="pax-icon icon-lodging filter-icon"></i>
                            {{ $t("SearchResults.ExtraBedCapacity") }}:
                            <span>{{ room.maximumExtraBed }}</span>
                          </div>
                        </div>
                      </div>
                      <div id="room-feature">
                        <div style="margin-left: 10px" v-if="room.breakfastIncluded === true"
                          class="tooltip_flip tooltip-effect-1 option the-icons">
                          <i class="room-fac-icon icon_set_1_icon-61 filter-icon"></i>

                          <span style="margin-bottom: 29px" class="tooltip-content-flip"><span style="font-size: 11px"
                              class="tooltip-back">{{ $t("SearchResults.Breakfast") }}
                            </span></span>
                        </div>

                        <div style="margin-left: 10px" v-if="room.smoking === false"
                          class="tooltip_flip tooltip-effect-1 option the-icons">
                          <i style="font-size: 33px" class="room-fac-icon icon_set_1_icon-47 filter-icon"></i>

                          <span style="margin-bottom: 29px" class="tooltip-content-flip"><span style="font-size: 11px"
                              class="tooltip-back">{{ $t("SearchResults.NoSmoking") }}
                            </span></span>
                        </div>

                        <div style="left: 35px !important" class="tooltip_position tooltip_flip tooltip-effect-1" v-if="
                          room.amenities.length > 0 || room.description !== ''
                        ">
                          <span style="margin-left: 32px" class="tooltip-content-flip"><span style="font-size: 11px"
                              class="tooltip-back">{{ $t("SearchResults.RoomDetails") }}</span></span>
                          <div v-if="
                            !showAmenities[
                            roomIndex.toString() + index.toString()
                            ]
                          ">
                            <div @click="
                              onShowAmenities(
                                roomIndex.toString() + index.toString()
                              )
                            " class="feature-list the-icons">
                              <i class="icon-feature icon_set_1_icon-74"></i>
                              <!-- <span class="i-name">امکانات اتاق</span> -->
                            </div>
                          </div>
                          <div v-else>
                            <div @click="
                              onHideAmenities(
                                roomIndex.toString() + index.toString()
                              )
                            " class="feature-list the-icons">
                              <i class="icon-feature icon-eye-off"></i>
                              <!-- <span class="i-name">امکانات اتاق</span> -->
                            </div>
                          </div>
                        </div>

                        <div class="tooltip_position tooltip_flip tooltip-effect-1">
                          <span style="margin-left: 32px" class="tooltip-content-flip"><span style="font-size: 11px"
                              class="tooltip-back">{{ $t("SearchResults.PriceDetails") }}</span></span>
                          <div v-if="
                            !showPrice[
                            roomIndex.toString() + index.toString()
                            ]
                          ">
                            <div @click="
                              onShowPrice(
                                roomIndex.toString() + index.toString()
                              )
                            " class="feature-list the-icons">
                              <i class="icon-feature icon_set_1_icon-35"></i>
                              <!-- <span class="i-name">امکانات اتاق</span> -->
                            </div>
                          </div>
                          <div v-else>
                            <div @click="
                              onHidePrice(
                                roomIndex.toString() + index.toString()
                              )
                            " class="feature-list the-icons">
                              <i class="icon-feature icon-eye-off"></i>
                              <!-- <span class="i-name">امکانات اتاق</span> -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <hr />
                    </div>
                    <!-- <div  v-if="room.smoking === false" class="option the-icons">
                          <i class="fa fa-home"></i>
                          <span class="i-name">سیگار مجاز است</span>
                        </div> amenities -->

                    <transition name="fade">
                      <div v-if="
                        showPrice[roomIndex.toString() + index.toString()]
                      " class="room-features">
                        <div style=" font-size: 12px;
                            padding: 10px 40px 10px 10px;0
                            background: #f3f9ff;
                          ">
                          <div style="margin-bottom: 18px; margin-right: -30px" class="row">
                            <span> {{ $t("SearchResults.PerNight") }} : </span>
                            <span>
                              {{ room.basePrice | numFormat | rial }}
                            </span>
                          </div>
                          <div class="row">
                            <div v-if="room.maximumExtraBed > 0" style="margin-left: 30px" class="row">
                              <span>{{ $t("SearchResults.َAdultExtraBed") }}  : </span>
                              <span>
                                {{ room.rackExtraBedPrice | numFormat | rial }}
                              </span>
                            </div>
                            <div v-else style="margin-left: 30px;color: #00c3e1;" class="row">
                              <span> <i class="icon-info-4"></i> </span>
                              <span>
                                {{ $t("SearchResults.WithoutExtraServices") }} 
                                
                              </span>
                            </div>
                            <div v-if="room.maximumExtraBed > 0" class="row">
                              <span>{{ $t("SearchResults.ChildExtraBed") }}  : </span>
                              <span>
                                {{ room.rackChildPrice | numFormat | rial }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>

                    <transition name="fade">
                      <div v-if="
                        showAmenities[roomIndex.toString() + index.toString()]
                      " class="room-features">
                        <div v-if="room.amenities.length > 0">
                          <i class="icon_color icon-quote-left-alt"></i>
                          <span id="title"> {{ $t("SearchResults.RoomAvailabilities") }}  : </span>
                          <label v-for="(item, index) in room.amenities" :key="index">{{ item }}
                            <span style="margin-left: 2px">،</span>
                          </label>
                        </div>

                        <div class="room_desc" v-if="room.description !== ''">
                          <i class="icon_color icon-pin"></i>

                          <span id="title"> {{ $t("SearchResults.Description") }}  : </span>
                          <label>{{ room.description }}</label>
                        </div>
                      </div>
                    </transition>

                    <div v-if="option.length > 1" class="room-divider"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3">
            <div class="room_price">
              <div>
                <span class="normal_price_list">{{
                    totalBasePrice(option) | numFormat | rial
                }}</span>
                <span>{{ totalFarePrice(option) | numFormat | rial }}</span>
                <small> {{ $t("SearchResults.PerNight") }} </small>

                <a v-if="checkIsDisable" style="width: 200px !important;margin: auto;!important"
                  class="cust_btn btn btn-block btn-primary">{{ $t("SearchResults.Select") }}</a>
                <a v-else @click="onSelectRoom(option)" class="cust_btn btn btn-block btn-primary">{{ $t("SearchResults.Select") }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="btn btn_choose_more" v-if="!showCombineRoom && !checkIsDisable" @click="nextPage()">{{ $t("SearchResults.SelectMore") }}</a>
    <a v-else class="btn btn_choose_more" disabled>{{ $t("SearchResults.SelectMore") }}</a>
  </div>
</template>

<script>
import Store from "../../views/tour/store/index";
import RoomCard from "./HotelRoomCard";
require("linqjs");
require("bootstrap");

export default {
  store: Store,
  name: "SelectRooms",
  props: {
    isDisableButton: Boolean,
    roomsAvail: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    RoomCard,
  },

  data() {
    return {
      showPrice: {},
      showAmenities: {},
      size: 4,
      pageNumber: 0,
      showCombineRoom: false,
      roomTypes: [],
      hotelId: 0,
      localee:"fa",
    };
  },

  created() {
    this.hotelId = this.$store.getters["Book/GetHotelId"];
    this.selectAllRoomTypes();
  },
  mounted() { },
  methods: {
    selectAllRoomTypes() {
      debugger
      var arr = [];
      this.localee = this.$i18n.locale;
      var locale = this.localee;
      // this.roomsAvail.availableRoomTypes.forEach((element) => {
      //   element[0].forEach((el) => {
      //     el.name = this.$i18n.messages[locale].RoomsList['RoomName15' ];
      //     console.log("Name is : " + el.name);
      //     arr.push(el);

      //   });
      // });
      var distntictArray = arr.reduce((seed, current) => {

        return Object.assign(seed, {
          [current.name]: current,
        });
      }, {});

      this.roomTypes = distntictArray;
      "arr distntict roomtype", distntictArray;
    },
    onSelectedCombinedRooms(items) {
      this.$emit("selected", items);
    },
    totalBasePrice: function (values) {
      return values.reduce((acc, val) => {
        return acc + parseInt(val.totalBasePrice);
      }, 0);
    },
    totalFarePrice: function (values) {
      return values.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },

    onSelectRoom(option) {
      this.$emit("selected", option);
    },
    combineRoom() {
      this.showCombineRoom = true;
    },
    onShowAmenities(id) {
      this.$set(this.showAmenities, id, true);
    },
    onHideAmenities(id) {
      this.$set(this.showAmenities, id, false);
    },

    onShowPrice(id) {
      this.$set(this.showPrice, id, true);
    },
    onHidePrice(id) {
      this.$set(this.showPrice, id, false);
    },
    nextPage() {
      this.pageNumber++;
    },
  },
  computed: {
    checkIsDisable() {
      return (this.isDisableButton = this.isDisableButton);
    },
    paginatedRoomsOption() {
      //   this.size = this.roomsOption.length;
      debugger
      const start = this.pageNumber * this.size,
        end = start + this.size;
      return this.roomsAvail.availableRooms.slice(0, end);
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .room_price div {
    padding-left: 0px !important;
  }

  .arrow {
    width: auto;
    position: relative !important;
    left: 15px !important;
    background: #00c3e1;
    margin-top: 15px !important;
  }

  .tour_list_desc {
    border-left: none !important;
  }

  .room_price {
    padding: 10px;
  }

}

@media all and (device-width: 768px) and (device-height: 1024px) {
  .room_price {
    padding: 0px !important;
  }

  .strip_all_tour_list.wow.fadeIn {
    padding: 5px 20px;
  }

  hr {
    border-top: none !important;
  }
}


.room_image {
  width: 100%;
}

.btn_choose_more {
  background: #f0f7ff;
  color: #0a6c9f;
}

.room-title {
  /* text-align: center; */
  font-size: 16px;
  /* margin-right: 19px; */
  margin-top: 12px;
}

.room-title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.room-title h2 span {
  color: #084a6a ;
}

.cust_btn {
  color: white !important;
  background: #084a6a  !important;
  transition: 0.4s;
  /* width: 215px; */
  margin: auto;
  margin-bottom: 15px;
}

.cust_btn:hover {
  background: #03264d !important;
}

.room_price small {
  font-size: 11px;
  color: #999;
  display: block;
  margin-bottom: 10px;
  line-height: 12px;
}

.room_price div {
  display: table-cell;
  /* vertical-align: middle; */
  text-align: center;
  padding-left: 25px;
}

.room_price {
  margin-left: inherit;
  /* margin-right: -15px; */
}

.room_price {
  display: table;
  /* height: 220px; */
  font-size: 18px;
  color: #217d0d;
  width: 100%;
}

.room_price .normal_price_list {
  display: block;
  text-decoration: line-through;
  color: #999;
  font-size: 20px;
  margin-top: 10px;
}

.feature-list {
  position: absolute;
  left: 15px;
}

.room-desc {
  display: flex;
}

.room-info {
  font-size: 14px;
  margin: auto;
}

.room-info #capacity {
  margin-left: 10px;
}

.room-info #exterabed {}

.room-divider {
  text-align: center;
  height: 1px;
  margin: 10px 0 10px 0;
  background-color: #e1e8ed;
}

.room {
  padding: 10px 10px 0px 10px;
}

.room #title {
  font-size: 16px;
  color: #0a6c9f ;
}

.room .option {
  margin-bottom: 8px !important;
  color: black;
}

.room-features {
  margin: 0px 15px 15px 15px;
  width: 100% !important;
}

#room-feature {
  margin: 19px 0px 10px 0px;
}

.room-features #title {
  color: #777777;
  line-height: 10px !important;
}

.room_desc {
  margin-top: 10px;
  margin-bottom: 10px;
}

.choice {
  display: grid;
}

.option-title i {
  font-size: 17px;
}

.option-title span {
  font-weight: bold;
}

.more-amenities {
  color: #0a6c9f ;
  cursor: pointer;
}

#room-feature {
  margin-top: 16px;
  margin-bottom: 16px;
  font-size: 14px;
  display: flex;
}

.icon-feature {
  font-size: 24px;
  color: #0a6c9f;
  cursor: pointer;
  transition: 0.4s;
}

.icon-feature:hover {
  font-size: 24px;
  color: #084a6a ;
  cursor: pointer;
}

.fade-enter-active {
  transition: opacity 1.3s;
}

.fade-leave-active {
  transition: opacity 0s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.btn_room {
  background: #f0f7ff;
  color: #0a6c9f  !important;
  width: 205px;
  position: absolute;
  left: 0;
  margin-left: 22px;
  cursor: pointer;
}

.icon_color {
  color: #084a6a ;
}

.btn_room:hover {
  background: #c8e0fa;
  color: #dbb85c;
}

.flight_title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.flight_title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.flight_title h2 span {
  color: #00c3e1;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.tooltip_position {
  position: absolute;
  left: 0;
}

.room-fac-icon {
  font-size: 26px;
  cursor: pointer;
}

.button {
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  position: relative;
  padding: 0.8em 1.4em;
  padding-right: 4.7em;
  background: #0a6c9f;
  border: none;
  color: white;
  transition: 0.2s;
}

.button:before,
.button:after {
  background: #f3b118;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  padding-top: inherit;
  padding-bottom: inherit;
  width: 2.8em;
  border-radius: 50px;
  content: "\00a0";
  font-family: "FontAwesome", sans-serif;
  font-size: 1.2em;
  text-align: center;
  transition: 0.2s;
  transform-origin: 50% 60%;
}

.button:hover {
  background: #0079a5;
}

.button:active,
.button:focus {
  background: #002e3f;
  outline: none;
}

.button {
  min-width: 15em;
  border-radius: 55px;
}

.arrow {
  width: auto;
  position: absolute;
  left: 15px;
  background: #fcbe2f;
}

.arrow:hover {
  background: #f0b325;
}

.arrow:active,
.arrow:focus {
  background: #f0b325;
}

.arrow:after {
  content: "\F054";
}

.arrow:hover:after {
  -webkit-animation: bounceright 0.3s alternate ease infinite;
  animation: bounceright 0.3s alternate ease infinite;
}


@-webkit-keyframes bounceright {
  from {
    -webkit-transform: translateX(0);
  }

  to {
    -webkit-transform: translateX(3px);
  }
}

@-webkit-keyframes wiggle {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(30deg);
  }
}

@keyframes bounceright {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(3px);
  }
}

@keyframes wiggle {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(30deg);
  }
}
</style>